import ItemHandlerSFC from "./ItemHandler.vue";
export type { IItemHandlerProps, IItemHandlerSelected } from "./props";
export type { IItemHandlerEmits } from "./emits";
export const ItemHandler = ItemHandlerSFC;
